import { render, staticRenderFns } from "./ChatCheckboxActivity.vue?vue&type=template&id=715b9824&scoped=true"
import script from "./ChatCheckboxActivity.vue?vue&type=script&lang=js"
export * from "./ChatCheckboxActivity.vue?vue&type=script&lang=js"
import style0 from "./ChatCheckboxActivity.vue?vue&type=style&index=0&id=715b9824&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b9824",
  null
  
)

export default component.exports